export default __webpack_public_path__ + "static/media/vsd.911d0222.svg";